import { BaseEntity } from "../base/base-entity";

export type ProcedureImportStatusType = {
  readonly hasDuplicateCustomPath: boolean;
  readonly hasInvalidJson: boolean;
  readonly hasInvalidFormSchema: boolean;
  readonly hasInvalidZip: boolean;
  readonly hasInvalidFileVersion: boolean;
};

export class ProcedureImportStatus extends BaseEntity {
  public readonly hasDuplicateCustomPath: boolean;
  public readonly hasInvalidJson: boolean;
  public readonly hasInvalidFormSchema: boolean;
  public readonly hasInvalidZip: boolean;
  public readonly hasInvalidFileVersion: boolean;

  constructor(props: ProcedureImportStatusType) {
    super();
    this.hasDuplicateCustomPath = props.hasDuplicateCustomPath;
    this.hasInvalidJson = props.hasInvalidJson;
    this.hasInvalidFormSchema = props.hasInvalidFormSchema;
    this.hasInvalidZip = props.hasInvalidZip;
    this.hasInvalidFileVersion = props.hasInvalidFileVersion;
  }

  static fromJSON(json: ProcedureImportStatusType) {
    return new ProcedureImportStatus(json);
  }
}

export type ProcedureImportStatusWithDestManageGroupIdType =
  ProcedureImportStatusType & {
    readonly noPermissionDestManageGroup: boolean;
    readonly destManageGroupId: string | null;
  };

export class ProcedureImportStatusWithDestManageGroupId extends ProcedureImportStatus {
  public readonly noPermissionDestManageGroup: boolean;
  public readonly destManageGroupId: string | null;

  constructor(props: ProcedureImportStatusWithDestManageGroupIdType) {
    super(props);
    this.noPermissionDestManageGroup = props.noPermissionDestManageGroup;
    this.destManageGroupId = props.destManageGroupId;
  }

  static fromJSON(json: ProcedureImportStatusWithDestManageGroupIdType) {
    return new ProcedureImportStatusWithDestManageGroupId(json);
  }
}
